import { Box, Stack } from "@mui/material";
import logo from "../images/pdlogo.png";

export default function ColorBarsPD({ width = 1920, height = 1080 }) {
   return (
      <>
         <Box
            sx={{
               backgroundColor: "rgba(255,255,255,1)",
               py: "0.93%", // ~10px at 1080px
               px: "1.04%", // ~20px at 1920px
               borderRadius: `${(10 / width) * 100}%`, // Scales with Output width
               mx: "auto",
               position: "absolute",
               left: "50%",
               top: "12%",
               transform: "translateX(-50%)",
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
            }}
         >
            <img 
               src={logo} 
               style={{ 
                  width: "70%", // Consistent relative size across all Output resolutions
                  height: "auto",
                  maxWidth: "100%",
                  display: "block"
               }} 
            />
         </Box>
         <Stack
            sx={{ width: "100%", height: "100%" }}
            alignItems='flex-start'
         >
            <Stack
               direction='row'
               justifyContent='flex-start'
               alignItems='stretch'
               sx={{ width: "100%", height: "60%" }}
            >
               <Box
                  sx={{
                     backgroundColor: "rgb(104,104,104)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(180,180,180)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(180,180,16)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(16,180,180)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(16,180,16)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(180,16,180)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(180,16,16)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(16,16,180)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(104,104,104)",
                     width: "11.111111%",
                  }}
               />
            </Stack>
            <Stack
               direction='row'
               justifyContent='flex-start'
               alignItems='stretch'
               sx={{ width: "100%", height: "10%" }}
            >
               <Box
                  sx={{
                     backgroundColor: "rgb(16,235,235)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(16,70,106)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(180,180,180)",
                     width: "66.6666667%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(16,16,235)",
                     width: "11.111111%",
                  }}
               />
            </Stack>
            <Stack
               direction='row'
               justifyContent='flex-start'
               alignItems='stretch'
               sx={{ width: "100%", height: "10%" }}
            >
               <Box
                  sx={{
                     backgroundColor: "rgb(235,235,16)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(72,16,118)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     background: "linear-gradient(90deg, black, white);",
                     width: "66.6666667%",
                  }}
               />
               <Box
                  sx={{
                     background: "rgb(235,16,16)",
                     width: "11.111111%",
                  }}
               />
            </Stack>
            <Stack
               direction='row'
               justifyContent='flex-start'
               alignItems='stretch'
               sx={{ width: "100%", height: "20%" }}
            >
               <Box
                  sx={{
                     backgroundColor: "rgb(47,47,47)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(0,0,0)",
                     width: "11.111111%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(255,255,255)",
                     width: "22.222222%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(0,0,0)",
                     width: "44.4444444%",
                  }}
               />
               <Box
                  sx={{
                     backgroundColor: "rgb(47,47,47)",
                     width: "11.111111%",
                  }}
               />
            </Stack>
         </Stack>
      </>
   );
}
